import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestService } from '@core/services/request/request.service';
import { TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { PositionDefinerFormComponent } from '../position-definer-form/position-definer-form.component';
import { Position } from '../position-definer-form/types';
import { Nullable } from '@core/helpers/nullable';

@Component({
  selector: 'x-position-definer-dialog',
  imports: [PositionDefinerFormComponent],
  templateUrl: './position-definer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionDefinerDialogComponent {
  private readonly requestService = inject(RequestService);
  readonly permissionService = inject(OutkeepPermissionService);
  readonly $request = this.requestService.$request;

  private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<
    Nullable<Position>
  >;

  onFormCompleted(position: Nullable<Position>) {
    this.context.completeWith(position);
  }
}
